// ©2024 Austin App House. All rights reserved.
import React from 'react';
import Clients from './ForClients';
import SuperAdmins from './ForSuperAdmins';
import Contractor from './ForContractors';

const WorkOrderButtonControl = ({
  hideControlButton,
  openImportModal,
  userType,
}) => {
  if (hideControlButton) return <></>;

  switch (userType) {
    case 'client': return (
      <Clients openImportModal={openImportModal} userType={userType} />
    );
    case 'contractor': return <Contractor userType={userType} />;
    case 'superAdmin': return (
      <SuperAdmins userType={userType} />
    );
    default: return <></>;
  }
};

export default WorkOrderButtonControl;
